module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "contentWrap"
    }
  }, [_c('div', {
    staticClass: "content left"
  }, [_c('div', {
    staticClass: "left",
    attrs: {
      "id": "content_1block"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pure-form pure-form-aligned"
  }, [_c('fieldset', {
    staticStyle: {
      "margin-left": "80px"
    }
  }, [_c('div', {
    staticClass: "pure-control-group",
    staticStyle: {
      "line-height": "50px"
    }
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Reset Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.strPsw),
      expression: "strPsw"
    }],
    staticClass: "pure-input-2-3",
    attrs: {
      "id": "password",
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.strPsw)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.strPsw = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pure-control-group",
    staticStyle: {
      "line-height": "50px"
    }
  }, [_c('label', {
    attrs: {
      "for": "confirm_password"
    }
  }, [_vm._v("Confirm Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.strConfirmPsw),
      expression: "strConfirmPsw"
    }],
    staticClass: "pure-input-2-3",
    attrs: {
      "id": "confirm_password",
      "type": "password",
      "placeholder": "Confirm Password"
    },
    domProps: {
      "value": (_vm.strConfirmPsw)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.strConfirmPsw = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pure-controls",
    staticStyle: {
      "margin-left": "230px"
    }
  }, [_c('button', {
    staticClass: "button-warning pure-button pure-button-primary",
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "type": "reset",
      "value": "Reset"
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button-warning pure-button pure-button-primary",
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.confirm()
      }
    }
  }, [_vm._v("Reset Password")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content_top"
    }
  }, [_c('div', {
    staticClass: "content_title_full left"
  }, [_vm._v("Reset Password")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-70929818!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/Resetpsw.vue
// module id = 112
// module chunks = 1